import { FC } from "react";
import Heading from "components/Heading/Heading";
import { useTranslation } from "react-i18next";

export interface Statistic {
  id: string;
  heading: string;
  subHeading: string;
}

export interface SectionStatisticProps {
  className?: string;
  borgo: any;
}

const SectionStatistic: FC<SectionStatisticProps> = ({ className = "", borgo }) => {

  const { t, ready } = useTranslation("translation");
  if (!ready) return null;

  const statisticsArray = t("translation:components.sectionStatistics.list", { returnObjects: true }) as Statistic[];

  return (
    <div className={`nc-SectionStatistic relative ${className}`}>
      <Heading
        desc={t("translation:components.sectionStatistics.description")}
      >
        {t("translation:components.sectionStatistics.heading")}
      </Heading>
      <div className="grid md:grid-cols-2 gap-6 lg:grid-cols-3 xl:gap-8">
        { 
          statisticsArray.map((statistic) => (
            <div
              key={statistic.id}
              className="p-6 bg-neutral-50 dark:bg-neutral-800 rounded-2xl dark:border-neutral-800"
            >
              <h3 className="text-2xl font-semibold leading-none text-neutral-900 md:text-3xl dark:text-neutral-200">
                {statistic.heading}
              </h3>
              <span className="block text-sm text-neutral-500 mt-3 sm:text-base dark:text-neutral-400">
                {statistic.subHeading}
              </span>
            </div>
          ))
        }
      </div>
    </div>
  );
};

export default SectionStatistic;
